<template>
	<div>
		<div class="menuTool" style="width:100%;">
			<el-row :gutter="10">
				<div class="search-title">
					仪表基础信息
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.actualNo" placeholder="请输入实际表号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.mainNo" placeholder="请输入主表号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.meterType" placeholder="仪表类型" clearable>
						<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.useStatus" placeholder="使用状态" clearable>
						<el-option v-for="item in useStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.billingFlag" placeholder="是否计费" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.autoFlag" placeholder="是否智能表" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="search-input-item">
					<el-select size="small" v-model="query.dummyFlag" placeholder="是否虚拟表" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>

				<div class="search-button-tools">
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.listPage'" :loading="tableLoading" @click="doSearch">查询</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.export'" v-debounce @click="doExport">导出</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.modifyPrice'" :disabled="disableMulAction" @click="doOpenChangePriceForm">改单价</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.basicImport'" @click="doBasicImport">基础导入</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.handworkImport'" @click="doHandleImport">手抄导入</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.historyImport'" @click="doHistoryImport">历史手抄数据导入</el-button>
					<el-button type="primary" size="small" v-Jurisdiction="'hydropower.web.meter.basic.stopImport'" @click="doBatchStop">批量停用</el-button>
				</div>

				<el-table
					:data="tableData"
					@selection-change="handleSelectionChange"
					row-key="id"
					border
					:stripe="true"
					v-loading="tableLoading"
					tooltip-effect="light"
				>
					<el-table-column width="55" fixed="left" type="selection"></el-table-column>
					<el-table-column width="200" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
					<el-table-column width="200" show-overflow-tooltip prop="actualNo" label="实际表号"></el-table-column>
					<el-table-column width="160" show-overflow-tooltip prop="mainNo" label="主表号"></el-table-column>
					<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
					<el-table-column width="160" show-overflow-tooltip prop="projectName" label="项目小区"></el-table-column>
					<el-table-column width="200" show-overflow-tooltip prop="floorName" label="楼栋"></el-table-column>
					<el-table-column width="100" show-overflow-tooltip prop="roomName" label="房间号"></el-table-column>

					<el-table-column width="150" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
					<el-table-column width="150" prop="price" label="单价" align="right">
						<template slot-scope="scope">
							{{ scope.row.price }}
							<el-button v-Jurisdiction="'hydropower.web.meter.basic.modifyPriceHistory'" @click="doOpenChangePriceRecordTable(scope.row)" type="text" size="small">详情</el-button>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="loss" label="线损"></el-table-column>
					<el-table-column width="100" prop="beilv" label="倍率"></el-table-column>
					<el-table-column width="150" prop="totalUse" label="累计使用度数/吨数" align="right"></el-table-column>
					<el-table-column width="150" prop="remainUse" label="剩余度数/吨数" align="right"></el-table-column>
					<el-table-column width="150" prop="useStatusStr" label="使用状态" align="right">
						<template slot-scope="scope">
							{{ scope.row.useStatusStr }}
                            <template v-if="isPermit('hydropower.web.meter.basic.replace') || isPermit('hydropower.web.meter.basic.mothball')">
							<el-button v-show="scope.row.useStatus == 0" @click="doOpenChangeStatusForm(scope.row)" type="text" size="small"
								>改状态</el-button>
                            </template>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="bindStatusStr" label="绑定状态" align="right"></el-table-column>
					<el-table-column width="180" prop="readDate" label="最后读表时间"></el-table-column>
					<el-table-column width="180" prop="createDate" label="创建时间"></el-table-column>
					<el-table-column width="150" prop="createByStr" label="创建者"></el-table-column>
					<el-table-column width="200" fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button
                                v-Jurisdiction="'hydropower.web.basic.handwork.listPage'" 
								v-if="scope.row.autoFlag == 0 && scope.row.handworkNum > 0"
								@click="doOpenHandworkTable(scope.row)"
								type="text"
								size="small"
								>手抄记录</el-button
							>
							<el-button v-Jurisdiction="'hydropower.web.meter.basic.edit'" @click="doOpenEditBasicInfoForm(scope.row)" type="text" size="small">修改</el-button>
							<el-button v-Jurisdiction="'hydropower.web.meter.basic.preStore'" v-if="scope.row.autoFlag == 0" @click="doOpenPreStoreForm(scope.row)" type="text" size="small">预存</el-button>
						</template>
					</el-table-column>
				</el-table>
				<simple-pagination @search="doSearch" />
			</el-row>
		</div>

		<el-dialog
			:title="changePriceDlg.title"
			width="370px"
			:visible.sync="changePriceDlg.visible"
			v-if="changePriceDlg.visible"
			:destroy-on-close="true"
		>
			<change-price-form @search="doSearch" :defaultFormData="changePriceDlg.formData"></change-price-form>
		</el-dialog>

		<el-dialog :title="importDlg.title" width="400px" :visible.sync="importDlg.visible" v-if="importDlg.visible" :destroy-on-close="true">
			<upload-excel :uploadUrl="importDlg.uploadUrl" :templateUrl="importDlg.templateUrl"></upload-excel>
		</el-dialog>

		<el-dialog :title="editDlg.title" width="800px" :visible.sync="editDlg.visible" v-if="editDlg.visible" :destroy-on-close="true">
			<edit-basic-info-form @search="doSearch" :defaultFormData="editDlg.formData"></edit-basic-info-form>
		</el-dialog>

		<el-dialog
			:title="changeStatusDlg.title"
			width="800px"
			:visible.sync="changeStatusDlg.visible"
			v-if="changeStatusDlg.visible"
			:destroy-on-close="true"
		>
			<change-status-form @search="doSearch" :defaultFormData="changeStatusDlg.formData"></change-status-form>
		</el-dialog>

		<el-dialog :title="preStoreDlg.title" width="450px" :visible.sync="preStoreDlg.visible" v-if="preStoreDlg.visible" :destroy-on-close="true">
			<pre-store-form @search="doSearch" :defaultFormData="preStoreDlg.formData"></pre-store-form>
		</el-dialog>

		<el-dialog :title="handworkDlg.title" :visible.sync="handworkDlg.visible" v-if="handworkDlg.visible" :destroy-on-close="true" width="90%">
			<handwork-table v-show="handworkDlg.visible" :meterId="handworkDlg.meterId"></handwork-table>
		</el-dialog>

		<el-dialog
			:title="changePriceRecordDlg.title"
			:visible.sync="changePriceRecordDlg.visible"
			v-if="changePriceRecordDlg.visible"
			:destroy-on-close="true"
			width="80%"
		>
			<change-price-record-table v-show="changePriceRecordDlg.visible" :meterId="changePriceRecordDlg.meterId"></change-price-record-table>
		</el-dialog>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import { useStatus, options, meterType } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import { assign, pick } from "lodash";
import HandworkTable from "./components/HandworkTable.vue";
import ChangePriceForm from "./components/ChangePriceForm.vue";
import EditBasicInfoForm from "./components/EditBasicInfoForm.vue";
import ChangeStatusForm from "./components/ChangeStatusForm.vue";
import PreStoreForm from "./components/PreStoreForm.vue";
import UploadExcel from "@/components/UploadExcel.vue";
import ChangePriceRecordTable from "./components/ChangePriceRecordTable.vue";
import { get } from "@/assets/common/request";
export default {
	name: "MeterBasic",
	components: {
		HandworkTable,
		ChangePriceRecordTable,
		UploadExcel,
		ChangePriceForm,
		EditBasicInfoForm,
		ChangeStatusForm,
		PreStoreForm,
	},
	mixins: [mixin],
	props: {
		parentData: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	data() {
		return {
			useStatus,
			options,
			meterType,
			queryListUrl: "/meter/web/basic/listPage",
			changePriceDlg: {
				title: "批量修改单价",
				visible: false,
				formData: {
					loss: 1,
				},
			},
			importDlg: {
				title: "",
				visible: false,
				uploadUrl: "",
				templateUrl: "",
			},
			editDlg: {
				title: "",
				visible: false,
				formData: {},
			},
			preStoreDlg: {
				title: "",
				visible: false,
				formData: {},
			},
			handworkDlg: {
				title: "",
				visible: false,
				meterId: "",
			},
			changePriceRecordDlg: {
				title: "",
				visible: false,
				meterId: "",
			},
			changeStatusDlg: {
				title: "",
				visible: false,
				type: 1,
				formData: {},
			},
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		doExport() {
			const title = "仪表基础数据";
			const url = "meter/web/basic/export";
			this._export(title, url);
		},
		doOpenChangePriceForm() {
			if (this.checkSelection()) {
				assign(this.changePriceDlg, {
					visible: true,
					formData: {
						loss: 1,
						price: 0,
						ids: this.getSelectionIds(),
					},
				});
			}
		},
		doOpenHandworkTable(rowData) {
			this.handworkDlg = {
				title: "手抄数据列表",
				visible: true,
				meterId: rowData.id,
			};
		},
		doOpenChangePriceRecordTable(rowData) {
			this.changePriceRecordDlg = {
				title: "单价调整历史记录",
				visible: true,
				meterId: rowData.id,
			};
		},
		doOpenEditBasicInfoForm(rowData) {
			const url = `/meter/web/basic/${rowData.id}`;
			const attributes = ["id", "actualNo", "loss", "meterType", "isPublic", "roomId", "dummyFlag", "remarks"];
			get(url).then(({ data }) => {
				this.editDlg = {
					title: `修改 表号${rowData.payMeterNo}`,
					visible: true,
					formData: pick(data, attributes),
				};
			});
		},
		doOpenPreStoreForm(rowData) {
			this.preStoreDlg = {
				title: `预存金额`,
				visible: true,
				formData: { id: rowData.id },
			};
		},

		doOpenChangeStatusForm(rowData) {
			this.changeStatusDlg = {
				title: `改状态 表号${rowData.payMeterNo}`,
				visible: true,
				formData: assign({}, { id: rowData.id }),
			};
		},
		doBasicImport() {
			this.importDlg = {
				title: "电表基础数据导入",
				visible: true,
				uploadUrl: "/meter/web/basic/basicImport",
				templateUrl: "meter/web/basic/basicTemplate",
			};
		},
		doHandleImport() {
			this.importDlg = {
				title: "手抄表数据导入",
				visible: true,
				uploadUrl: "/meter/web/basic/handworkImport",
				templateUrl: "meter/web/basic/handleTemplate",
			};
		},
		doHistoryImport() {
			this.importDlg = {
				title: "手抄历史数据导入",
				visible: true,
				uploadUrl: "/meter/web/basic/historyImport",
				templateUrl: "meter/web/basic/historyTemplate",
			};
		},
		doBatchStop() {
			this.importDlg = {
				title: "停用电表据导入",
				visible: true,
				uploadUrl: "/meter/web/basic/stopImport",
				templateUrl: "meter/web/basic/stopTemplate",
			};
		},
	},
	watch: {
		parentData(val) {
			this.query = assign(this.query, this.parentData);
			this.doSearch();
		},
	},
	mounted() {
		this.query = assign(this.query, this.parentData);
		this.doSearch();
	},
};
</script>
